///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import {
    Component,
    ViewEncapsulation,
    OnInit,
    AfterViewInit,
    OnDestroy,
    Injector,
} from "@angular/core";
import { TranslationsProvider } from "../../../core/translations.provider";
import { AuthorizationService } from "../../../core/auth/authorization.service";

@Component({
    templateUrl: "./landing-page.view.component.html",
    styleUrls: ["./landing-page.view.component.css"],
})
export class LandingPageViewBaseComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    public $authorizationService: AuthorizationService;

    public $modules = [
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-pie-chart",
            },
            label: "Booking",
            labelKey: "modules.Booking.label",
            name: "Booking",
            url: "booking",
            title: "View and manage supplier bookings",
            children: [
                {
                    name: "SupplierData",
                    routerLink: "/booking/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "SupplierDataDetails",
                    routerLink: "/booking/supplier-data-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "Test",
                    routerLink: "/booking/test",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-pie-chart",
            },
            label: "HistoricalBookings",
            labelKey: "modules.HistoricalBookings.label",
            name: "HistoricalBookings",
            url: "historical-bookings",
            title: "View and manage supplier historical bookings",
            children: [
                {
                    name: "SupplierData",
                    routerLink: "/historical-bookings/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "SupplierDataDetails",
                    routerLink: "/historical-bookings/supplier-data-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-drivers-license-o",
            },
            label: "Contact Info",
            labelKey: "modules.Contact.label",
            name: "Contact",
            url: "contact",
            title: "View contact information",
            children: [
                {
                    name: "ContactInfo",
                    routerLink: "/contact/contact-info",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-users",
            },
            label: "Group Booking",
            labelKey: "modules.GroupBooking.label",
            name: "GroupBooking",
            url: "group-booking",
            title: "View and manage supplier group bookings",
            children: [
                {
                    name: "SupplierData",
                    routerLink: "/group-booking/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "SupplierDataDetails",
                    routerLink: "/group-booking/supplier-data-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-bus",
            },
            label: "Service Line",
            labelKey: "modules.ServiceLine.label",
            name: "ServiceLine",
            url: "service-line",
            title: "View and manage Service Line Lists",
            children: [
                {
                    name: "ServiceLine",
                    routerLink: "/service-line/service-line",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "ServiceLineDetails",
                    routerLink: "/service-line/service-line-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-cutlery",
            },
            label: "Group Services",
            labelKey: "modules.GroupService.label",
            name: "GroupServices",
            url: "group-services",
            title: "View and manage group services",
            children: [
                {
                    name: "GroupService",
                    routerLink: "/group-service/services",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "GroupServiceDetails",
                    routerLink: "/group-service/service-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-bus",
            },
            label: "Shuttle Service",
            labelKey: "modules.ShuttleService.label",
            name: "ShuttleService",
            url: "Shuttle Service",
            title: "View and manage Shuttle Services",
            children: [
                {
                    name: "ShuttleService",
                    routerLink: "/shuttle-service/shuttle-service",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "ShuttleServiceDetails",
                    routerLink: "/shuttle-service/shuttle-service-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-bus",
            },
            label: "Guided Tours",
            labelKey: "modules.GuidedTours.label",
            name: "GuidedTours",
            url: "Guided Tours",
            title: "View Guided Tours",
            children: [
                {
                    name: "GuidedTours",
                    routerLink: "/guided-tours",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    name: "GuidedToursDetails",
                    routerLink: "/guided-tours/guided-tours-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
        {
            description: "",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-coffee",
            },
            label: "Exchange Point",
            labelKey: "modules.ExchangePoint.label",
            name: "ExchangePoint",
            url: "exchange-point",
            title: "View and manage exchange points",
            children: [
                {
                    name: "SupplierData",
                    routerLink: "/exchange-point/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ] as View[],
        },
    ];

    constructor(public injector: Injector) {
        this.$authorizationService = this.injector.get(AuthorizationService);

        this.filterModules();

        const translationsProvider = this.injector.get(TranslationsProvider);
        translationsProvider.useDefaultLanguage();
    }

    public ngOnInit(): void {
        this["onInit"]();
    }

    public ngAfterViewInit(): void {
        this["onShow"]();
    }

    public ngOnDestroy(): void {
        this["onHide"]();
    }

    private filterModules(): void {
        this.$modules.forEach((module) => {
            module.children = module.children.filter((view) =>
                this.$authorizationService.isAuthorized(view.authorization)
            );
        });

        this.$modules = this.$modules.filter((m) => m.children.length);
    }
}

interface View {
    name: string;
    routerLink: string;
    authorization: {
        allowedRoles: any[];
    };
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/landing-page/landing-page.view.base.component.ts